/*
 * PROD-7828 R14 P4/P6 — the rules routes (releases/R14-P4-API.md). URL building and envelope unwrapping
 * only; bodies come from logic.js. Every route is grant-gated like the rest of the module.
 */
import { get_api, post_api } from '../../../../redux/api_funcs';
import { get_api_url } from '../../../../utils/urls';
import { envelope_data } from '../format';
import { build_query_string } from '../overview/params';

const RULES = '/v2/cms_user/teacher_payments/rules';

const url = (path, params = {}) => {
  const q = build_query_string(params);
  return get_api_url(`${RULES}${path}${q ? `?${q}` : ''}`);
};

// Static per build: labels for codes and the allowed month-parameter values.
export const fetch_rules_catalogue = () => get_api(url('/catalogue'), true).then(envelope_data);

// at: 'YYYY-MM-DD' (IST); '' = today.
export const fetch_rules_list = (at = '') =>
  get_api(url('/list', at ? { at } : {}), true).then(envelope_data);

export const fetch_rule_history = (rule_key) =>
  get_api(url('/history', { rule_key }), true).then(envelope_data);

export const fetch_rule_change = (change_uuid) =>
  get_api(url('/change', { change_uuid }), true).then(envelope_data);

export const fetch_rule_changes = (before_id = 0, limit = 20) =>
  get_api(url('/changes', before_id ? { before_id, limit } : { limit }), true).then(envelope_data);

export const fetch_preview_lines = (preview_uuid, limit = 100, offset = 0) =>
  get_api(url('/preview/lines', { preview_uuid, limit, offset }), true).then(envelope_data);

export const post_rule_change = (body) => post_api(url('/changes'), body, true).then(envelope_data);

export const post_rule_preview = (change_uuid) =>
  post_api(url('/change/preview'), { change_uuid }, true).then(envelope_data);

export const post_rule_apply = (change_uuid, preview_uuid) =>
  post_api(url('/change/apply'), { change_uuid, preview_uuid }, true).then(envelope_data);

// R14 P6 approvals: the queue, then the maker's request and withdrawal and the checker's verdict.
export const fetch_rule_approvals = () => get_api(url('/approvals'), true).then(envelope_data);

export const post_rule_request_approval = (change_uuid, preview_uuid, note) =>
  post_api(url('/change/request_approval'), { change_uuid, preview_uuid, note }, true).then(
    envelope_data
  );

export const post_rule_approve = (change_uuid, preview_uuid, note) =>
  post_api(url('/change/approve'), { change_uuid, preview_uuid, note }, true).then(envelope_data);

export const post_rule_reject = (change_uuid, note) =>
  post_api(url('/change/reject'), { change_uuid, note }, true).then(envelope_data);

export const post_rule_withdraw = (change_uuid, note) =>
  post_api(url('/change/withdraw'), { change_uuid, note }, true).then(envelope_data);

export const post_rule_cancel_approval = (change_uuid, note) =>
  post_api(url('/change/cancel_approval'), { change_uuid, note }, true).then(envelope_data);
